import $ from 'jquery'
import postContentSize from './content_size'

$("#pros_and_cons_card_pros_footnote, #pros_and_cons_card_cons_footnote").on("change keyup paste", function(){
  defaultProsAndConsCardHandler();
});

for(let i = 1; i <= 6; i++) {
  $("#pros_and_cons_card_pros_"+i+"_title, #pros_and_cons_card_cons_"+i+"_title, #pros_and_cons_card_pros_"+i+"_icon_id, #pros_and_cons_card_cons_"+i+"_icon_id").on("change keyup paste", function(){
    defaultProsAndConsCardHandler();
  });
}

function defaultProsAndConsCardHandler(){
  var fields = {}
  fields["pros_footnote"] = $("#pros_and_cons_card_pros_footnote").val()
  fields["cons_footnote"] = $("#pros_and_cons_card_cons_footnote").val()

  for(let i = 1; i <= 6; i++) {
    fields["pros_"+i+"_title"] = $("#pros_and_cons_card_pros_"+i+"_title").val()
    fields["pros_"+i+"_icon_id"] = $("#pros_and_cons_card_pros_"+i+"_icon_id").val()
    fields["cons_"+i+"_title"] = $("#pros_and_cons_card_cons_"+i+"_title").val()
    fields["cons_"+i+"_icon_id"] = $("#pros_and_cons_card_cons_"+i+"_icon_id").val()
  }

  postContentSize("pros_and_cons", "/content_size/pros_and_cons", fields)
  .done(function( data ) {
    $("#pros_footnote_error").hide()
    $("#cons_footnote_error").hide()
    for(let i = 1; i <= 6; i++) {
      $("#pros_"+i+"_title_error").hide()
      $("#cons_"+i+"_title_error").hide()
    }
    if(!data["valid"]) {
      data["errors"].forEach(function(error) {
        if("pros_footnote_error" == error){
          $("#pros_footnote_error").show()
        }
        else if("cons_footnote_error" == error){
          $("#cons_footnote_error").show()
        } 
        else{
          for(let i = 1; i <= 6; i++) {
            if($("#pros_and_cons_card_pros_"+i+"_title").val() == error){
              $("#pros_"+i+"_title_error").show()
            }
            if($("#pros_and_cons_card_cons_"+i+"_title").val() == error){
              $("#cons_"+i+"_title_error").show()
            }
          }
        }
      });
    }
  });
}